import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'
import type {
  ContentActionButtonItem,
  ContentBarcodeItem,
  ContentDetailsItem,
  ContentHeaderItem,
  ContentItem,
  ContentListItem,
  ContentSection,
  ContentSeparatorItem,
  ContentSpacerItem,
  ContentTextWidgetItem,
} from 'src/api/types'

import {Details} from '../details'
import {DrawerSection} from '../drawer'
import {ActionButton} from './ActionButton'
import {Barcode} from './barcode'
import * as classes from './Content.classes'
import {Header} from './Header'
import {ListItem} from './ListItem'
import {Separator} from './Separator'
import {Spacer} from './Spacer'
import {TextWidget} from './TextWidget'

type Props = {
  sections: ContentSection[]
}

type AnyContentItem = ContentItem | ContentActionButtonItem | ContentSpacerItem

type ComponentsMap<Map extends Record<string, AnyContentItem> = Record<string, AnyContentItem>> = {
  [K in keyof Map]: React.FC<{item: Map[K]}>
}

const componentsMap: ComponentsMap<{
  details: ContentDetailsItem
  header: ContentHeaderItem
  list_item: ContentListItem
  separator: ContentSeparatorItem
  barcode: ContentBarcodeItem
  text_widget: ContentTextWidgetItem
  action_button: ContentActionButtonItem
  spacer: ContentSpacerItem
}> = {
  details: Details,
  header: Header,
  list_item: ListItem,
  separator: Separator,
  barcode: Barcode,
  text_widget: TextWidget,
  action_button: ActionButton,
  spacer: Spacer,
}

const Content: React.FC<Props> = ({sections}) => {
  return (
    <>
      {sections.map((section, index) => (
        <DrawerSection className={classes.drawerSection} key={index}>
          <Grid className={classes.section} container>
            {section.items.map((item, itemIndex) => {
              const componentKey = item.type as keyof typeof componentsMap
              const Component = componentsMap[componentKey]

              if (!Component) {
                return null
              }

              return (
                <Grid
                  className={clsx(item.type !== 'separator' && item.type !== 'header' && classes.sectionItem)}
                  container
                  item
                  key={itemIndex}
                >
                  <Grid item xs={12}>
                    <Component item={item as never} />
                  </Grid>
                </Grid>
              )
            })}
          </Grid>
        </DrawerSection>
      ))}
    </>
  )
}

export default Content
